<template>
    <div  class="publicViewClass app-inner">
        <div class="show_container" :class="authType ? 'show_container1' : ''">
             <div class="staff_manage_head">
                <div class="top_mange flex align-cen">
                       <div class="search_box">
                     <el-input placeholder="学员姓名" v-model="search" clearable> </el-input>
                </div>
                <div class="search_box" style="margin-left:30px">
                     <el-input placeholder="学员手机号码" v-model="search1" clearable> </el-input>
                </div>
                 <div class="public-btn-small flex align-cen" style="padding-left:20px">
                    <div class="public-btn-small-primary"  @click="gethisList">搜索</div>
                    <div class="public-btn-small-primary"  style="margin-left:10px" v-if="!authType" @click="openClass">批量修改分类</div>
                    <div class="public-btn-small-text" @click="reset">重置筛选条件</div>
                </div>
                </div>
                <div class="bottom_mange">
             <div class="staff_search flex align-cen">
                <div class="staff_search_label">学员组分类：</div>
                <div class="search_box1">
                      <el-select
                        v-model="value"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </div>
               </div>
                     <div class="staff_search flex align-cen">
                <div class="staff_search_label">学员关联仿真系统：</div>
                <div class="search_box1">
                      <el-select
                        v-model="value1"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in options1"
                        :key="item.id"
                        :label="item.appName"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </div>
               </div>
                </div>
             </div>
                 <div class="staff_manage_center">
                 <div class="businessList-container-table">
                             <el-table
                ref="multipleTable"
                :data="itemList"
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                  :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
                >
                 <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left" > </el-table-column>
                   <el-table-column prop="userName" label="学员姓名" align="center">
                 </el-table-column>
                  <el-table-column prop="avatar" label="学员头像" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.avatar || require('../../../assets/images/head.png')" alt="" style="width:40px;height:40px;border-radius: 50%;">
                    </template>
                 </el-table-column>
                 <el-table-column prop="loginName" label="手机号码" align="center">
                 </el-table-column>
                 <el-table-column label="学员分类" align="center"  width="300" >
                    <template slot-scope="scope">
                        <div class="flex align-cen" style="justify-content:center" v-if="scope.row.traineeClassifyRelationList.length">
                      <div v-for="(item,index) in scope.row.traineeClassifyRelationList"  class="tagbq">
                            {{item.classifyName}}
                        </div>
                        </div>
                        <div v-else>-</div>
                    </template>
                 </el-table-column>
                 <el-table-column label="关联仿真系统" align="center">
                     <template slot-scope="scope">
                        <p style="color:red;cursor:pointer" @click="openAppList(scope.row)">{{scope.row.allocateNum}}</p>
                     </template>
                 </el-table-column>
                 <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="250"       
                    v-if="!authType"   
                    >
                      <template slot-scope="scope">
                      <el-button type="text" @click="openS(scope.row)">学员档案</el-button> 
                       <el-button type="text" @click="setS(scope.row)">设定分类</el-button> 
                        <el-button type="text" style="color:red" @click="deletS(scope.row)">删除</el-button> 
                     </template>
                   </el-table-column>
                 </el-table-column>
                  </el-table>
                   <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                 </div>
                 </div>
        </div>
                     <!-- 已分配系统弹窗 -->
           <el-dialog
  title="已分配系统"
  :visible.sync="centerDialogVisible"
  width="60%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  >
     <div class="businessList-container-table">
    <el-table
          ref="multipleTable1"
          :data="systesList"
          tooltip-effect="dark"
          style="width: 100%"
          id='mytable'
          :header-cell-style="{background:'#fff',color:'#90909e',paddingBottom:'20px'}"
        >
         <el-table-column prop="appName" label="系统名称" align="center" width="300">
          </el-table-column>
           <el-table-column  label="登录次数" align="center">
            <template slot-scope="scope">
                <p>{{scope.row.loginNum || '-'}}</p>
            </template>
          </el-table-column>
            <el-table-column  label="最后学习时间" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.lastStudyTime || '-'}}</p>
            </template>
          </el-table-column>
          <el-table-column  label="考试次数" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.examNum || '-'}}</p>
            </template>
          </el-table-column>
               <el-table-column  label="仿真考试次数" align="center" width="200">
            <template slot-scope="scope">
                <p >{{scope.row.assessNum || '-'}}</p>
            </template>
          </el-table-column>
          <el-table-column  label="考试合格次数" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.passNum || '-'}}</p>
            </template>
          </el-table-column>
    </el-table>
   </div>
           </el-dialog>
              <!-- 设定分类 -->
                         <el-dialog
  title="设置学员分类"
  :visible.sync="centerDialogVisible1"
  width="35%"
  :append-to-body="true"
  :show-close="false"
  center
  v-if="centerDialogVisible1"
  >
    <div class="setdia">
        <div class="setdia-set" v-if="!isCheck">
             <div class="setdia-con flex align-cen" v-if="dynamicTags.length">
                <div class="label">设定学员分类：</div>
                <div class="classItem">
                   <el-tag
                    :key="tag.id"
                    v-for="tag in dynamicTags"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag.id)">
                    {{tag.name}}
                    </el-tag>
                </div>
                <div class="setbtn mft" @click="openChek">
                    选择分类
                </div>
            </div>
            <div class="nodyna" v-else>
                <p> 暂未设定学员分类</p>
                <div class="setbtn" @click="openChek">
                    选择分类
                </div>
            </div>
           <div class="businessList-filter-list flex align-cen public-btn-small" style="justify-content:center;padding-left:0px">
                         <div class="public-btn-small-plan" style="margin-right:30px" @click="centerDialogVisible1 = false">
                        取消
                        </div>
                          <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load"
                            @click.stop="putClass"
                            >
                              确定
                            </el-button>
                    </div>
        </div>
        <div class="setdia-check" v-if="isCheck">
             <div class="checkAll">
                 <el-checkbox-group v-model="checkList">
                    <el-checkbox v-for="item in options" :label="item.id">{{item.name}}</el-checkbox>
                 </el-checkbox-group>
             </div>
              <div class="businessList-filter-list flex align-cen public-btn-small" style="justify-content:center;padding-left:0px">
                         <div class="public-btn-small-plan" style="margin-right:30px" @click="isCheck = false">
                        取消
                        </div>
                          <el-button type="primary" class="public-btn-small-primary public-btn-small-load"
                            @click.stop="putCheck"
                            >
                              确定
                            </el-button>
                    </div>
        </div>
    </div>
  </el-dialog>
                <!-- 批量设定分类 -->
                         <el-dialog
  title="批量设置学员分类"
  :visible.sync="centerDialogVisible2"
  width="35%"
  :append-to-body="true"
  :show-close="false"
  center
  v-if="centerDialogVisible2"
  >
  <div class="setdia">
         <div class="setdia-check">
             <div class="checkAll">
                 <el-checkbox-group v-model="checkList">
                    <el-checkbox v-for="item in options" :label="item.id">{{item.name}}</el-checkbox>
                 </el-checkbox-group>
             </div>
              <div class="businessList-filter-list flex align-cen public-btn-small" style="justify-content:center;padding-left:0px">
                         <div class="public-btn-small-plan" style="margin-right:30px" @click="centerDialogVisible2 = false">
                        取消
                        </div>
                          <el-button type="primary" class="public-btn-small-primary public-btn-small-load"
                            @click.stop="setclass"
                            >
                              确定
                            </el-button>
                    </div>
        </div>
  </div>
</el-dialog>
    </div>
</template>
<script>
import { getAllStudentClass,getTeacherAppList,getStudentList,saveTraineeClassifyRelation,batchSaveTraineeClassifyRelation} from "@/api/enterprise/index"; // 全部学员分类、学员关联仿真系统、学员列表、学员详情、设置学员分类
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'studentList', 
     components:{
      paginaTion
    },
      props: {
    authType:[String, Number],
    },
    data() {
        return {
            centerDialogVisible2:false,
            selsctarr:[],
            multipleSelection:[],
            groupIds:[],
            checkList:[],
            loading:false,
            isCheck:false,
            centerDialogVisible1:false,
            centerDialogVisible:false,
            search:'',
            search1:'',
            options:[],
            options1:[],
            value:'',
            value1:'',
            bussID:'',
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            itemList:[],
            systesList:[],
            dynamicTags:[],
            userid:'',
            businessId:'',
            officialType:''
        }
    },
    created () {
        const businessInfo = this.$locaStorage.setAge().get('businessInfo')
         this.bussID = businessInfo.id
         this.officialType= this.$locaStorage.setAge().get('officialType')
         this.getallClass()
         this.getwin()
         this.gethisList()
    },
    methods: {
        // 打开批量修改窗口
        openClass(){
            if(this.multipleSelection.length !=0){
                 this.checkList = []
                 this.groupIds = []
                this.centerDialogVisible2 = true
            }else{
                this.$util.Notifi('请先勾选学员','error','fa-exclamation-circle')
            }
        },
        // 批量设置分类
        setclass(){
            this.groupIds = this.multipleSelection.map(item => item.id)
            if(this.checkList.length == 0 ) return this.$util.Notifi('至少选择一个分类','error','fa-exclamation-circle') 
            let params = {
            accountIds:this.groupIds,
            businessId:this.bussID,
            classifyIds:this.checkList
           }
         batchSaveTraineeClassifyRelation(params,'enterprise')
           .then(res =>{
             if(res.code == 0){
                 this.$util.Notifi('批量分类修改成功','success','fa-check')
                 this.centerDialogVisible2 = false
                 this.$refs.multipleTable.clearSelection();
                  this.gethisList()
             }else{
                this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
             }
           })
        },
        steditfun(val){
         
            this.selsctarr = val
        },
          // 新增修改调用清空方法
        remove(){
           this.multipleSelection = []
        },
           getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
         this.multipleSelection = this.uniqueUsers(val);
        this.$emit('sendStatus', this.multipleSelection,false)
      },
    //   去重
    uniqueUsers(data) {
      const seen = new Set();
      return data.filter(user => {
        if (seen.has(user.id)) {
          return false;
        }
        seen.add(user.id);
        return true;
      });
    },
        putCheck(){
         if(!this.checkList.length) return this.$util.Notifi('请先勾选','error','fa-exclamation-circle')
         this.isCheck = false
         this.dynamicTags = this.options.filter(item => this.checkList.some(ele=>ele===item.id))
        },
        //  为设定分类时打开选择学员分类
        openChek(){
            this.isCheck = true
            if(!this.dynamicTags.length){
                this.checkList = []
            }
        },
        // 标签移除
        handleClose(tag){
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
           this.checkList = this.checkList.filter(item => this.dynamicTags.some(ele=>ele.id===item))
        },
        // 打开设定学员分类窗口
        setS(data){
            this.dynamicTags = []
            this.checkList = []
            this.userid = data.id
            this.businessId = data.businessId
            for (let key in data.traineeClassifyRelationList) {
                this.dynamicTags.push({
                    name:data.traineeClassifyRelationList[key].classifyName,
                    id:data.traineeClassifyRelationList[key].classifyId
                })
                this.checkList.push(data.traineeClassifyRelationList[key].classifyId)
            }
            this.centerDialogVisible1 = true
        },
        // 设定学员
        putClass(){
            let traineeClassifyRelationList = []
            for (const key in this.checkList) {
                traineeClassifyRelationList.push(
                    {
                        classifyId:this.checkList[key]
                    }
                )
            }
            // console.log(traineeClassifyRelationList)
            let params = {
                id:this.userid,
                businessId:this.businessId,
                traineeClassifyRelationList:traineeClassifyRelationList
            }
            this.loading = true
             saveTraineeClassifyRelation(params,'enterprise')
            .then(res => {
             this.loading = false
            if(res.code == 0){
                 this.$util.Notifi('设定成功','success','fa-check');
                   setTimeout(() => {
                           this.centerDialogVisible1 = false
                           this.gethisList()
                   }, 100);
            }else{
                 this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
            }
            })
            .catch(err => {
                 this.loading = false
            })
        },
        // 打开学员详情
        openS(data){
            this.$router.push({
                name:'studentDetail',
                query:{
                    businessId:data.businessId,
                    id:data.id
                }
            })
        },
        // 删除跳转企业管理后台deletS
        deletS(data){
             const newurl = this.$router.resolve({name: 'teamAdmin', query: {}})
             window.open(newurl.href,'_blank')
        },
        // 打开关联仿真系统
        openAppList(data){
        this.centerDialogVisible = true
        this.getSystem(data)
        },
          getSystem(data){
             getTeacherAppList({id:data.businessId,accountId:data.id,officialType:this.officialType},'enterprise')
            .then(res =>{
               this.systesList = res.data
            })
        },
                 // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisList()
      },
        // 学员分类
    getallClass(){
        getAllStudentClass({businessId:this.bussID,name:''},'enterprise')
        .then(res =>{
           this.options = res.data
        })
        .catch(err =>{})
    },
    // 关联仿真系统
    getwin(){
    getTeacherAppList({id:this.bussID,accountId:'',officialType:this.officialType},'enterprise')
        .then(res =>{
          this.options1 = res.data
        })
        .catch(err =>{})
    },
    classSelect(){
        this.currentPage = 1
        this.gethisList()
    },
     reset(){
        this.value = ''
        this.search = ''
         this.search1 = ''
         this.value1 = ''
          this.currentPage = 1
        this.gethisList()
     }, 
     gethisList(){
         let params = {
                businessId:this.bussID,
                size:this.PageSize,
                current:this.currentPage,
                classifyId:this.value,
                userName:this.search,
                loginName:this.search1,
                appId:this.value1
            }
        getStudentList(params,'enterprise')
        .then(res =>{
            this.itemList = res.data.records
            this.totalCount = res.data.total
           if(this.authType){
            //  console.log(this.selsctarr)
             let rows = []
               rows = res.data.records.filter(item => this.selsctarr.some(item1 => item.id == (item1.businessId ? item1.id :item1.allocateId)))
                rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row,true)
                })
           }
        })
        .catch(err =>{})
     },  
    },
}
</script>
<style lang="scss" scoped>
.show_container1{
    max-width: auto !important;
    min-width: auto !important;
}
.staff_manage_head{
    height: 200px !important;
    line-height: none !important;
    padding: 20px 40px 0 40px !important;
}
.tagbq{
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
    display: inline-block;
    height: 32px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 12px;
    color: #409eff;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    margin-right: 10px;
}
::v-deep{
    .setdia{
        .setdia-check{
            padding: 0 50px;
            .el-checkbox{
                display: block;
                padding-bottom: 10px;
            }
        }
        .setdia-con{
            padding-bottom: 50px;
            .label{
                width: 160px;
            }
            .classItem{
                .el-tag{
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
            .setbtn{
                width: 135px;
               background: #155bd4;
                   height: 32px;
                line-height: 30px;
                font-size: 14px;
                padding: 0 20px;
                border-radius: 2px;
                font-family: inherit;
                border-width: 1px;
                border-style: solid;
                text-align: center;
                vertical-align: middle;
                box-sizing: border-box;
                cursor: pointer;
                transition: all 0.3s;
                background: #155bd4;
                color: #fff;
            }
        }
        .nodyna{
            text-align: center;
            p{padding: 20px 0;}
             .setbtn{
               background: #155bd4;
                   height: 32px;
                line-height: 30px;
                font-size: 14px;
                padding: 0 20px;
                border-radius: 2px;
                font-family: inherit;
                border-width: 1px;
                border-style: solid;
                text-align: center;
                vertical-align: middle;
                box-sizing: border-box;
                cursor: pointer;
                transition: all 0.3s;
                background: #155bd4;
                color: #fff;
                margin: 0 auto;
                margin-bottom: 20px;
                width: 100px;
            }
        }
    }
      .jiange{
      padding-bottom: 20px;
      padding-right: 20px;
    }
    .el-table__body{

        td{
           padding: 5px 0;
        }
    }
    }
</style>